import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    if (!["Enter", " "].includes(event.key)) return

    event.preventDefault()
    this.element.click()
  }
}
